import { useState } from "react";
import { ToastContainer, toast } from "react-toastify";
import registerLanding_api from "../../../api/registerLanding";
import { DaniiBTCBannerMoving } from "../../../component/ui/daniibtc-banner-moving";

export default function Registration() {
  const [phone, setPhone] = useState("");
  const handleChange = (e) => {
    const input = e.target.value;
    setPhone(input);
  };
  const [name, setName] = useState("");

  const handleChangee = (e) => {
    const input = e.target.value;
    setName(input);
  };
  const handleToPaymentWay = async () => {
    if (!name.trim() || name.trim().split(" ").length < 2) {
      toast.error("نام و نام خانوادگی را کامل وارد کنید");
      return;
    }
    if (!/^09\d{9}$/.test(phone)) {
      toast.error("شماره موبایل معتبر نیست");
      return;
    }
    toast.success("درحال انتقال به درگاه ...");
    const register_data = await registerLanding_api(name, phone);
    if (register_data[1] === 200) {
      window.open(register_data[0].gateway_link, "_self");
    }
    console.log(register_data);
  };
  return (
    <div
      id="registerForm"
      className="font-black text-white w-[500px]  max-[600px]:w-[300px] flex items-center justify-center m-auto flex-col py-20"
    >
      <ToastContainer theme="dark" rtl={true} position="bottom-right" />

      <div className="m-auto h-[677px] w-[500px] max-[600px]:w-[300px]">
        <DaniiBTCBannerMoving />
      </div>
      <h2 className="text-3xl max-[600px]:text-2xl text-center">
        فرم ثبت نام و مشاوره&nbsp;
        <span className="text-[#7E42FF]">دوره ساخت توکن</span>
      </h2>

      <div className="space-y-4 my-5">
        <div className="flex flex-col space-y-1">
          <label
            htmlFor="firstName"
            className="text-sm text-white text-right font-normal p-2"
          >
            : نام و نام خانوادگی
          </label>
          <input
            type="text"
            value={name}
            onChange={handleChangee}
            placeholder="حسین حسینی"
            className="px-3 py-4 rounded-md text-[#2B2B2B]   font-black  placeholder:font-light text-right focus:outline-none focus:ring-2 focus:[#7E42FF] w-[490px]  max-[600px]:w-[290px]"
          />
        </div>

        <div className="flex flex-col space-y-1">
          <label
            htmlFor="firstName"
            className="text-sm text-white text-right font-normal p-2"
          >
            : تلفن همراه (ترجیحا واتساپ فعال)
          </label>
          <input
            type="text"
            maxLength={11}
            value={phone}
            onChange={handleChange}
            placeholder="09123456789"
            className="px-3 py-4 rounded-md text-[#2B2B2B]  placeholder:font-light text-right focus:outline-none focus:ring-2 focus:[#7E42FF]"
          />
        </div>
      </div>
      <button
        className="bg-[#7E42FF] w-[490px] py-4 rounded-xl font-bold  max-[600px]:w-[290px] transition-transform transform hover:scale-105 hover:bg-[#5E32CC]"
        onClick={handleToPaymentWay}
      >
        پرداخت هزینه ثبت نام
      </button>
      <span className="font-normal py-4 max-[600px]:text-md text-center">
        با کلیک روی دکمه به صفحه پرداخت امن هدایت میشی
      </span>
    </div>
  );
}
